export default "__VITE_ASSET__BgmN3sJP__"